<template>
  <div
    :class="[$style.header, backIcon ? '' : $style.border_bottom]"
    :style="{ ...styles }"
  >
    <div :class="$style.top">
      <div :class="$style.top__left">
        <div :class="$style.button">
          <icon-button
            v-if="backIcon"
            data-testid="gp_autotest_filter_sidebar_back_button"
            :icon="{ name:'arrow-left' }"
            size="small"
            @onClick="$emit('backClick')"
          />
        </div>
        <div :class="$style.title">
          {{ title }}
        </div>
      </div>
      <div :class="$style.top__right">
        <icon-button
          v-if="helpIcon"
          data-testid="gp_autotest_filter_sidebar_help_button"
          :icon="{ name:'help' }"
          size="small"
          :style="{color: helpIconColor }"
          @onClick="$event => helpClick($event)"
        />
        <icon-button
          data-testid="gp_autotest_filter_sidebar_close_button"
          :icon="{ name:'close-1' }"
          size="small"
          @onClick="$emit('closeClick')"
        />
      </div>
    </div>
    <div
      v-if="componentName === 'filterMain' && !blockFilterSave && accessToSavedFilters"
      :class="$style.filters_dropdown"
    >
      <dropdown-select
        gp-autotest-name="gp_autotest_filter_saved_filters_dropdown"
        :drop-list="options"
        :placeholder="locales('filter_select_saved_filters')"
        :multiselect="false"
        :show-selected-first="false"
        :show-reset-btn="true"
        :highlight-active-state="false"
        :item-template="'text'"
        :field-map="{ text: 'name' }"
        :outline="'none'"
        :custom-class="'filter_cmp_saved_filters_dropdown'"
        :use-select-all="false"
        :popup-max-height="200"
        :arrow-icon="{
          name: 'arrow-down',
          type: 'regular',
          size: 24
        }"
        :selected="selectedFilter ? [selectedFilter] : []"
        @selected="selectFilter"
        @onResetClick="$emit('onResetClickFromHeader')"
      />
    </div>
  </div>
</template>

<script>
import dropdownSelect from '$$commonComp/dropdownSelect/dropdownSelect.vue';
import iconButton from '$$uiKitComp/globalButton/withIcon/iconButton.vue';
import pricingHelpers from '../../../helpers/pricingHelper';

export default {
  components: { iconButton, dropdownSelect },
  props: {
    title: { type: String, required: true, default: '' },
    backIcon: { type: Boolean, required: false, default: false },
    helpIcon: { type: Boolean, required: false, default: false },
    options: { type: Array, required: false, default: () => [] },
    selectedFilter: { type: Object, required: false, default: () => null },
    styles: { type: Object, required: false, default: () => {} },
    componentName: { type: String, required: true, default: '' },
    blockFilterSave: { type: Boolean, required: false, default: false },
  },
  emits: {
    backClick: null,
    closeClick: null,
    onResetClickFromHeader: null,
    helpClick: Object,
    selectFilter: Object,
    showHelpPopup: Object,
  },
  data() {
    return {
      locales: __,
    };
  },
  computed: {
    accessToSavedFilters() {
      return pricingHelpers.checkPricingAccess('saving_filters');
    },
    helpIconColor() {
      const activityStatus = this.$store.getters['user/getActivityStatus']('filterViewHelpPopup');

      if (activityStatus) {
        return '#808080';
      }

      return '#E65100';
    },
  },
  methods: {
    selectFilter(selected) {
      this.$emit('selectFilter', selected);
    },
    helpClick(e) {
      this.$store.dispatch('user/updateActivityStatus', { activityName: 'filterViewHelpPopup', status: 1 });
      this.$emit('showHelpPopup', {
        event: e,
        id: 'filterViewHelpPopup',
      });
    },
  },
};
</script>

<style module lang='less'>
@import '../../../less/_mixins.less';
@import '../../../less/_fonts.less';

.header {
  padding: 12px;

  .top {
    display: flex;
    justify-content: space-between;

    &__left {
      display: flex;

      .button {
        display: flex;
        margin-right: 4px;
      }

      .title {
        width: 200px;
        .FontLatoBold;
        .fs(16px, 26px);
        color: #191919;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        cursor: default;
      }
    }

    &__right {
      display: flex;
      gap: 4px;
    }
  }

  .filters_dropdown {
    padding-top: 20px;
  }

  &.border_bottom {
    border-bottom: 1px solid #e5e5e5;
  }
}
</style>
